"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapProductBoxesFromGql = void 0;
var _mapProductBoxPropsFromGql = require("./mapProductBoxPropsFromGql");
const mapProductBoxesFromGql = ({
  data,
  isAnonymousUser,
  mode,
  overrides
}) => data.filter(product => product !== null).map(product => (0, _mapProductBoxPropsFromGql.mapProductBoxPropsFromGql)({
  data: product,
  overrides,
  mode,
  isAnonymousUser
})).filter(product => product !== null);
exports.mapProductBoxesFromGql = mapProductBoxesFromGql;
//# sourceMappingURL=mapProductBoxesFromGql.js.map